export const HELP_ITEM_ID = {
  PORTAL_TOUR: 'help-portal-tour',
  DOCS: 'help-docs',
  CHANGELOG: 'help-changelog',
  SHARE_FEEDBACK: 'help-share-feedback',
  KEYBOARD_SHORTCUTS: 'help-keyboard-shortcuts',
  DISCORD: 'help-discord',
} as const
